import {FormattedMessage} from 'react-intl';

import {createElement} from 'rlink-react';
import themeable from 'rlink-theme/themeable';

export default function AgeGateLockout ({theme}) {
  return (
    <div className={theme.Lockout}>
      <div className={theme.Message}>
        <h1>
          <FormattedMessage
            id="ui.label.title.AGE_GATE_DENIED"
            defaultMessage="Sorry"
            description="Heading for the message indicating the user did not pass the age verification form." />
        </h1>
        <h3>
          <FormattedMessage
            id="ui.text.info.AGE_GATE_DENIED"
            defaultMessage="You do not meet the criteria to view this content"
            description="Message informing the user they did not pass the age verification form." />
        </h3>
      </div>
    </div>
  );
}

themeable(AgeGateLockout, {
  classes: [
    'Lockout',
    'Message',
  ],
});



// WEBPACK FOOTER //
// ./lib/rlink-agegate/components/AgeGateLockout.jsx